import { createContext } from 'react';

export const AMICALE_STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  READY: 'ready',
  ERROR: 'error',
};

export const AmicaleContext = createContext({
  status: AMICALE_STATUS.IDLE,
  isAmical: false,
  client: null,
  refresh: () => {},
});
